import { gql } from '@apollo/client';
import { FieldFragment } from 'graphql/Field/fragments/FieldFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @const FieldGroupsValuesQuery
 * @since 1.0.0
 */
export const FieldGroupsValuesQuery = gql `
  query FieldGroupsValuesQuery(
    $input: FieldGroupsInput
    $valueInput: FieldValueEntityInput
  ) {
    fieldGroups(input: $input) {
      id
      title
      infos
      category

      fields {
        id
        type
        name
        title
        infos
        options
        value(input: $valueInput)
        order
        defaultValue
        defaultValueLocked
        active

        translations {
          id
          title
          infos
          createdAt
          updatedAt

          language {
            ...LanguageFragment
          }
        }
      }

      translations {
        id
        title
        infos

        language {
          ...LanguageFragment
        }
      }

      unifiedFields(input: $valueInput) {
        ...FieldFragment
        unifiedValue(input: $valueInput)
      }
    }
  }

  ${LanguageFragment}
  ${FieldFragment}
`;
